import script from "./PreSportsSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./PreSportsSlider.vue?vue&type=script&setup=true&lang=js"

import "./PreSportsSlider.vue?vue&type=style&index=0&id=132f34b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-132f34b7"]])

export default __exports__